<template>
<div class="orderData np-marketing-analysis">
    <div class="total bgc">
        <div class="left">
            <div class="outbox">
                <div class="innerbox">
                    <div class="box">
                        <el-tooltip content="活动的全部成交订单数" placement="top">
                            <div class="name">
                                <span>订单总数</span>
                                <i class="tip el-icon-info"></i>
                            </div>
                        </el-tooltip>
                        <div class="value tc-blue">{{orderinfo.totalordercount}}</div>
                    </div>
                    <div class="box">
                        <!--<el-tooltip content="活动的浏览人数，同一个人多次访问算 1 次" placement="top">-->
                            <!--<div class="name">-->
                                <!--<span>参与人数(UV)</span>-->
                                <!--<i class="tip el-icon-info"></i>-->
                            <!--</div>-->
                        <!--</el-tooltip>-->
                        <!--<div class="value tc-green">{{orderinfo.uviewcount}}</div>-->
                    </div>
                    <div class="box">
                        <el-tooltip content="活动的订单转化率，等于总订单数/总访问人数" placement="top">
                            <div class="name">
                                <span>总转化率</span>
                                <i class="tip el-icon-info"></i>
                            </div>
                        </el-tooltip>
                        <div class="value tc-red">{{orderinfo.transrate}}</div>
                    </div>
                </div>
            </div>
            <div class="outbox">
                <div class="innerbox">
                    <div class="box">
                        <el-tooltip :content="summaryinfo.begindate+'至'+summaryinfo.enddate+'的订单数'" placement="top">
                            <div class="name">
                                <span>时段订单数</span>
                                <i class="tip el-icon-info"></i>
                            </div>
                        </el-tooltip>
                        <div class="value tc-blue">{{summaryinfo.allordercount}}</div>
                    </div>
                    <div class="box">
                        <!--<el-tooltip :content="summaryinfo.begindate+'至'+summaryinfo.enddate+'的访问人数'" placement="top">-->
                            <!--<div class="name">-->
                                <!--<span>时段访问人数</span>-->
                                <!--<i class="tip el-icon-info"></i>-->
                            <!--</div>-->
                        <!--</el-tooltip>-->
                        <!--<div class="value tc-green">{{summaryinfo.alluviewcount}}</div>-->
                    </div>
                    <div class="box">
                        <el-tooltip :content="summaryinfo.begindate+'至'+summaryinfo.enddate+'的转化率'" placement="top">
                            <div class="name">
                                <span>时段转化率</span>
                                <i class="tip el-icon-info"></i>
                            </div>
                        </el-tooltip>
                        <div class="value tc-red">{{summaryinfo.allorderrate}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="right">
            <div class="filters bgc">
                <div class="add">
                    <el-button type="danger" @click="handleQuery(1)" :class="[param.timetype!=1?'is-disabled': '']">今天</el-button>
                    <el-button type="primary" @click="handleQuery(2)" :class="[param.timetype!=2?'is-disabled': '']">昨天</el-button>
                    <el-button type="success" @click="handleQuery(3)" :class="[param.timetype!=3?'is-disabled': '']">近7天</el-button>
                    <el-button type="warning" @click="handleQuery(4)" :class="[param.timetype!=4?'is-disabled': '']">近30天</el-button>
                </div>
                <div class="search">
                    <el-date-picker class="dateInput" v-model="date" type="daterange" align="right" unlink-panels
                                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
                    </el-date-picker>
                    <el-button type="primary" @click="handleQuery(0)">确认筛选</el-button>
                    <el-button type="success" @click="handleExport">下载表格</el-button>
                </div>
            </div>
            <div>
                <lineReport :lineDatas="lineDatas" class="lineDatas"></lineReport>
            </div>
        </div>
    </div>
    <div class="list">
        <div class="dateTime blod"><span class="blod">{{summaryinfo.begindate}}</span> 至 <span class="blod">{{summaryinfo.enddate}}</span></div>
        <div class="result-list btn-operate-list bgc">
            <el-table :data="tableData" style="width: 100%" border>
                <el-table-column prop="date" label="时间" class-name="center"></el-table-column>
                <el-table-column prop="ordercount" label="订单量" class-name="center"></el-table-column>
                <el-table-column prop="orderrate" label="转化率" class-name="center"></el-table-column>
            </el-table>
        </div>
    </div>
</div>
</template>

<script>
import LineReport from 'base/echarts/lineReport'
import {mapActions} from 'vuex'
import {dateFormat} from 'common/js/tools'
import {getEventDataStatisticsByOrder, exportEventDataStatisticsByOrder, getDataSummary} from 'api/brandBusiness'
export default {
    name: 'orderData',
    data() {
        return {
            init: false,
            tableData: [],
            summaryinfo: {
                begindate: '',
                enddate: '',
                allavgviewcount: '0.00',
                alluviewcount: 0,
                allviewcount: 0
            },
            lineDatas: {id: 'orderData', subText: '', xdata: [], data: [], legendAddr: 'left', formatter: '{a0}: {c0}'},
            date: [],
            datatype: 2, // 1用户统计 2订单统计 3财务统计 4分享统计 5裂变统计
            param: {
                timetype: 3, // 时间类型 0自定义 1今日 2昨日 3近7日 4近30日
                eventinnerid: '',
                begindate: '',
                enddate: ''
            },
            orderinfo: {
                totalordercount: '', // 订单总数
                uviewcount: '', // 参与人数UV
                transrate: '' // 总转化率=订单总数/参与人数UV
            }
        }
    },
    mounted() {
    },
    methods: {
        handleQuery(index) {
            if (!index && !this.date.length) {
                this.$message.error('请选择筛选日期')
                return false
            } else if (!index && !!this.date.length) {
                this.param.begindate = this.date[0]
                this.param.enddate = this.date[1]
            }
            this.param.timetype = index
            this._getTotal()
        },
        getTotal(param) {
            this.param.eventinnerid = param.eventinnerid
            if (!this.init) {
                this._getDataSummary()
                this._getTotal()
            }
        },
        handleExport() {
            this.setLoading(true)
            exportEventDataStatisticsByOrder({
                data: this.param,
                success: data => {
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '订单数据' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getTotal() {
            this.setLoading(true)
            getEventDataStatisticsByOrder({
                data: this.param,
                success: data => {
                    this.tableData = data.data.datalist
                    this.summaryinfo = data.data.summaryinfo
                    this.lineDatas.xdata = data.data.datelist
                    this.lineDatas.data=[]
                    this.lineDatas.data.push(
                        {
                            title: '订单数',
                            color: '#1989FA',
                            smooth: true,
                            symbol: 'circle',
                            list: data.data.ordercountlist
                        }
                    )
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        _getDataSummary() {
            getDataSummary({
                data: {eventinnerid: this.param.eventinnerid, datatype: this.datatype},
                success: data => {
                    this.init = true
                    this.orderinfo = data.data.orderinfo
                },
                error: data => {
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions(['setLoading'])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        LineReport
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/index";
.orderData{

}
</style>
